var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcResetFilter3024PxRed(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 11.724,
    height: 13.727,
    viewBox: "0 0 11.724 13.727",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ic_forward_30_24px",
    transform: "translate(0.25 0.57)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "ic_forward_30_24px-2",
    "data-name": "ic_forward_30_24px",
    d: "M4,8.744a5.417,5.417,0,0,0,5.612,5.163,5.417,5.417,0,0,0,5.612-5.163h-1.4a4.063,4.063,0,0,1-4.209,3.872A4.063,4.063,0,0,1,5.4,8.744,4.063,4.063,0,0,1,9.612,4.872V7.454l3.507-3.227L9.612,1V3.581A5.417,5.417,0,0,0,4,8.744Z",
    transform: "translate(-4 -1)",
    fill: "#eb1600",
    stroke: "#eb1600",
    strokeWidth: 0.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcResetFilter3024PxRed);
export default __webpack_public_path__ + "static/media/ic_reset_filter_30_24px_red.90026e3ecb564f16b1243662e05b2bf6.svg";
export { ForwardRef as ReactComponent };